var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaytm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_365",
    transform: "scale(0.03125 0.0344828)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_365",
    width: 32,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAdCAYAAADLnm6HAAACw0lEQVRIDe2WX0hTURzHhaKopFfNZ01RQ6K0CCv785Rm9FJRlPlg4EuQZmVBOAm2Zlg4KId/QAIfJFdppaUMmrlZ6dAUc7DKqVttmst2z7m7e/DbOdck2IZt/mkQ/uBytrtzv7/P+f5+5+5EIcIRFeH8WAUI6sDs7CwkSYIoiqCULuniGlyLawaLAAA+cTkS+4NzzWAQAQCc1v/h5frOtf0jAGAlVj+/AK7tHwEA85NXalwF+H8dIITC5SHg40L9E5IDHo+A0QkXPtm+wWafhEAIXFNufB5z4qvzOzyCIH92//gpz5ucnoF5iuCkmWBshl8U42y0ugmmGJTVTWUNDuYfQXfBsNWOxKMqxGcrkXxMjcZn76Gq7cDWHBUyTt9Dq34AKccr0GYYxO4zVah82oc4g4Q1rygKR7zIHpCQ0i0i3ujD3rcUCSYfakbnnAkJoP+jDVGpl3CkUIttLFHe9Ua0dw2hsLwJ0RmlKFLrsDG9FI9e9iEmqwxVTUac7SfYrKdotlOk9kjI7SVIMnqR+U7Enh6CNOPcaz0sgKx8DRJzlDhR3IDMcxpsOaDA2rTLKLnzBNG7SrEvT4MNO6+iXmeC9gtFrMELO7M+2SSh3CLgcJ8PF4ZE5PcLSOhahAMx+28i/dRdaJu6sImt/FZ1O+IOKlBR34nyB+0y1LrtJahv/gMw8RtAYSEyQAEHGCCLAShCsfqx3HzjjknEMquTWF+s33EFlQ16XFTqkJSrYqW4hhb9B1QzB2KYAzIAK0HZiIBDZh8Khrw4zwHehFECB+v023Wd6DQNy1tKEAhevB6EsqZDvs97pPF5L8rut6GO2c93Q7eT4IaFYpp1vdYmwuCkeDguotVB0WInqA2nCRfax0v9LaQmXGqShZ5fBfirAxE/kET8SBbxQymvEYfgTixHObgG1wp2Iua5Av4N+c1/Gb8A8j6oiKvb0fwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaytm);
export default __webpack_public_path__ + "static/media/paytm.d605747f7a0b25f9e07b137e7cbb4246.svg";
export { ForwardRef as ReactComponent };